import React, { memo } from 'react';
const FailOutlined = memo(props => {
  return React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    className: ['bcz-icon', props.className].filter(Boolean).join(' '),
    style: Object.assign({
      verticalAlign: '-0.125em'
    }, props.style)
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29293 7.99998L3.64648 4.35353L4.35359 3.64642L8.00004 7.29287L11.6465 3.64642L12.3536 4.35353L8.70714 7.99998L12.3536 11.6464L11.6465 12.3535L8.00004 8.70708L4.35359 12.3535L3.64648 11.6464L7.29293 7.99998Z"
  }));
});
export default FailOutlined;